/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M8.7295 5.0303a.7418.7418 0 0 0 0-1.0606c-.2975-.293-.7798-.293-1.0774 0l-7.295 7.1818a1.2083 1.2083 0 0 0-.112.1267 1.1857 1.1857 0 0 0 0 1.4436c.0337.0442.071.0865.112.1267l7.295 7.1818c.2976.2929.78.2929 1.0774 0a.7417.7417 0 0 0 0-1.0606L1.65 12l7.0796-6.9697Zm15.0255 6.2479a1.209 1.209 0 0 0-.112-.1267l-7.2951-7.1818c-.2975-.293-.7799-.293-1.0774 0a.7418.7418 0 0 0 0 1.0606L22.3501 12l-7.0796 6.9697a.7417.7417 0 0 0 0 1.0606c.2975.2929.7799.2929 1.0774 0l7.2951-7.1818a1.209 1.209 0 0 0 .112-.1267 1.1857 1.1857 0 0 0 0-1.4436Z"
    clipRule="evenodd"
  />,
  'Code'
);
